angular.module('zc.zenclerkS')
  .factory('ZcsEstimator', ZcsEstimator);

ZcsEstimator.$inject = ['$q', 'AccessStats'];
function ZcsEstimator($q, AccessStats) {
  const DAYS_PER_MONTH = 30;
  const service = {
    getEstimatedMonthlyStatsForSegment,
    calculateEstimations,
  };

  return service;

  function calculateEstimations(project, accessStats, daysSinceCreated, effectiveDays) {
    if(!project || !accessStats) {
      return {
        estimatedMonthlyCouponRevenue: 0,
        estimatedMonthlyConversionPrice: 0,
        estimatedMonthlyConversionUsers: 0,
        totalConversionPrice: 0,
        totalConversionCount: 0,
        totalDaysSinceSegmentCreation: 0,
        totaleffectiveDays: 0,
        totalStatDays: 0,
      };
    }

    let monthMultiplier = DAYS_PER_MONTH / effectiveDays;
    let totalConversionPrice = 0;
    let totalConversionCount = 0;

    _.each(accessStats, stats => {
      stats.estimated_coupon_revenue = calculateEstimatedCouponRevenue(project, stats.conversion_price);
      totalConversionPrice += stats.conversion_price;
      totalConversionCount += stats.conversion_count;
    });

    let totalEstimatedCouponRevenue = calculateEstimatedCouponRevenue(project, totalConversionPrice);

    let estimatedMonthlyConversionPrice = totalConversionPrice * monthMultiplier;
    let estimatedMonthlyConversionUsers = totalConversionCount * monthMultiplier;
    let estimatedMonthlyCouponRevenue = totalEstimatedCouponRevenue * monthMultiplier;

    let result = {
      estimatedMonthlyCouponRevenue: estimatedMonthlyCouponRevenue,
      estimatedMonthlyConversionPrice: estimatedMonthlyConversionPrice,
      estimatedMonthlyConversionUsers: estimatedMonthlyConversionUsers,
      totalConversionPrice: totalConversionPrice,
      totalConversionCount: totalConversionCount,
      totalDaysSinceSegmentCreation: daysSinceCreated,
      totaleffectiveDays: effectiveDays,
      totalStatDays: accessStats.length
    };
    return result;
  }

  function calculateEstimatedCouponRevenue(project, conversionPrice) {
    return conversionPrice *
      ((100 - project.pc_control_percent) / 100) *
      project.estimated_cv_cover_rate *
      project.estimated_ai_coupon_multiplier;
  }

  function getEstimatedMonthlyStatsForSegment(project, segment) {
    return $q((resolve, reject) => {
      // Use segment creation day to evaluate how many days should be taken
      // into account. We cannot use accessStats.length because if there is
      // not a single access, no access stats will be created.
      // + 1 because we want to count whole days
      const daysSinceCreated = moment().diff(moment(segment.created_at), 'days') + 1;
      const effectiveDays = _.min([DAYS_PER_MONTH, daysSinceCreated]);

      AccessStats.find({
        dimension: 'daily',
        apikey: project.apikey,
      }, {
        match: {
          campaign_segment_id: segment.id,
          is_control: null,
          device: null,
          start_at: {
            $gte: moment().subtract(effectiveDays, 'days').startOf('day').toDate(),
            $lt: moment().subtract(1, 'days').endOf('day').toDate(),
          }
        },
        sort: {
          start_at: -1
        },
      }).then(accessStats => {
        if(_.get(accessStats, 'success') === false) {
          return resolve({});
        }
        resolve(calculateEstimations(project, accessStats, daysSinceCreated, effectiveDays));
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/estimator.service.js